import api from "api/api";

// Fast & Furious — staffing needs, mission service.
// need: client_id OR client_name_freetext, job_id, title, description, keywords[].
// Weekly review: dedicated routes per declaration (GET list + PATCH answer).

// Active needs of the declarant ("besoin concerné" select). At least one filter
// is required (otherwise 400 need_filter_required) → we pass is_active=true.
export const getActiveNeedsQuery = async () =>
  await api.get(`/mission/need?is_active=true`);

// Needs attached to a declaration (edit list "being added").
export const getNeedsByDeclarationQuery = async (declarationId) =>
  await api.get(`/mission/need?declaration_ids=${declarationId}`);

export const createNeedQuery = async ({ payload }) =>
  await api.post(`/mission/need`, payload);

// Editing a need (declaration_id present but ignored on the back side).
export const updateNeedQuery = async ({ id, payload }) =>
  await api.put(`/mission/need/${id}`, payload);

// Deleting a need: back-gated (owner + current declaration
// + no dependency); no body, no query-param.
export const deleteNeedQuery = async ({ id }) =>
  await api.delete(`/mission/need/${id}`);

// List of needs to review for the current declaration: [{ need, still_active }]
// (still_active = null until answered).
export const getNeedReviewsQuery = async (declarationId) =>
  await api.get(`/mission/need-review/${declarationId}`);

// Saves/updates the review answer for a need (upsert): { need_id, still_active }.
export const patchNeedReviewQuery = async ({ declarationId, payload }) =>
  await api.patch(`/mission/need-review/${declarationId}`, payload);
